import axios, { AxiosInstance, AxiosResponse } from 'axios'
import { AnexoDtoDescricao, TokenUploadDto } from './_models'

const API_URL = process.env.REACT_APP_API_URL

const ATENDIMENTO_PUBLIC_URL = `${API_URL}/public/atendimento`

/**
 * Cria instância do Axios para requisições públicas com token
 */
export const createPublicAxios = (tokenUpload: string): AxiosInstance => {
  return axios.create({
    baseURL: ATENDIMENTO_PUBLIC_URL,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${tokenUpload}`,
    },
  })
}

/**
 * Valida token
 * @param token Bearer token
 * @returns Informacoes do token
 */
export const checkToken = (token: string): Promise<TokenUploadDto> => {
  const publicAxios = createPublicAxios(token)

  return publicAxios.get('/token').then((resp: AxiosResponse<TokenUploadDto>) => resp.data)
}

/**
 * Envia anexo para um atendimento
 * @param token Bearer token
 * @param descricao string
 * @param file File
 * @returns
 */
export const sendAnexo = (token: string, descricao: string, file: File) => {
  const publicAxios = createPublicAxios(token)

  const formData = new FormData()
  formData.append('anexo', file)
  formData.append('descricao', descricao)
  return publicAxios.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * Adiciona procedimento/exame a um atendimento
 * @param token Bearer token
 * @param file AnexoDtoDescricao
 * @returns
 */
export const sendProcedimento = (token: string, file: AnexoDtoDescricao) => {
  const publicAxios = createPublicAxios(token)
  return publicAxios.put('/procedimento', file, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

/**
 * Envia anexos para um atendimento
 * @param token Bearer token
 * @param files File[]
 * @param descricao string
 * @returns
 */
export const sendProcedimentos = (token: string, files: File[], descricao: string) => {
  const publicAxios = createPublicAxios(token)

  const formData = new FormData()

  files.forEach((file) => {
    formData.append('anexos', file)
  })
  formData.append('descricao', descricao)

  return publicAxios.post(`${ATENDIMENTO_PUBLIC_URL}/uploads`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
